import XIcon from '@duyank/icons/regular/X';
import { SerializedPage } from '@lidojs/design-core';
import { useEditor } from '@lidojs/design-editor';
import axios from 'axios';
import React, { FC, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useAsync } from 'react-use';
import Masonry from 'react-responsive-masonry';
import Photo from './Photo';
import AppContext from 'libs/AppContext';

interface Template {
  id: string;
  img: string;
  // elements: SerializedPage;
}

const TemplateContent: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [templateCategory, setTemplateCategory] = useState('');
  const { actions, activePage, state } = useEditor((state) => ({
    activePage: state.activePage,
  }));
  useAsync(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const listData = new FormData();
    listData.append('folder', urlParams.get('tc'));
    setTemplateCategory(urlParams.get('tc'));
    const UPLOAD_URL = "https://vectordad.com/apps/editor/api/templates/";
    const listjson = await axios.post(UPLOAD_URL + "listjson.php", listData);
    setTemplates(listjson.data);
    setIsLoading(false);
    /* try {
      axios.defaults.baseURL = 'https://vectordad.com/apps/editor/api/';
      const response = await axios.get<Template[]>('/templates/' + urlParams.get('tc') + '/data.json');
      // console.log(response);
      setTemplates(response.data);
      setIsLoading(false);
     } catch(error) {
      console.error(error);
    } */
  }, []);
  const addPage = async (data: Template) => {
    AppContext.templateId = data.id;
    if (AppContext.isAdmin) {
      window.open("https://vectordad.com/apps/editor/?tc=" + templateCategory + "&id=" + AppContext.templateId,"_self")
    } else {
      const APIURL = 'https://vectordad.com/apps/editor/api';
      const response = await fetch(APIURL + '/templates/' + templateCategory + '/'+ data.id +'.json');
      let responseJson = await response.json();
      actions.setPage(activePage, responseJson[0]);
      actions.setData(responseJson);
    }
    if (isMobile) {
      onClose();
    }
  };
  return (
    <div
      css={{
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        overflowY: 'auto',
        display: 'flex',
      }}
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          height: 48,
          borderBottom: '1px solid rgba(57,76,96,.15)',
          padding: '0 20px',
        }}
      >
        <p
          css={{
            lineHeight: '48px',
            fontWeight: 600,
            color: '#181C32',
            flexGrow: 1,
          }}
        >
          Templates
        </p>
        <div
          css={{
            fontSize: 20,
            flexShrink: 0,
            width: 32,
            height: 32,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={onClose}
        >
          <XIcon />
        </div>
      </div>
      <div
        css={{ flexDirection: 'column', overflowY: 'auto', display: 'flex' }}
      >
        {/* <div
          css={{
            flexGrow: 1,
            overflowY: 'auto',
            display: 'grid',
            gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
            gridGap: 8,
            padding: '16px',
          }}
        >
          {isLoading && <div>Loading...</div>}
          {templates.map((item, index) => (
            <div
              key={index}
              css={{ cursor: 'pointer' }}
              onClick={() => addPage(item)}
            >
              <img loading="lazy" src={item.img} />
            </div>
          ))}
        </div> */}
        <div
          css={{
            flexGrow: 1,
            overflowY: 'auto',
            padding: '16px',
            gridGap: 8,
          }}
        >
          <Masonry columnsCount={2} gutter="8px">
            {templates.map((item, idx) => (
              <Photo
                css={{
                  border: '1px solid #d9d9d9'
                }}
                key={idx}
                image={item.img}
                username=''
                url={undefined}
                onClick={() => {
                  addPage(item);
                }}
              />
            ))}
          </Masonry>
          {isLoading && <div>Loading...</div>}
        </div>
      </div>
    </div>
  );
};

export default TemplateContent;
